import TypographyHeading from "../Typography/Heading";
import styles from "./styles.module.css";

type DrawerHeaderTitleProps = {
  title: string;
};

const DrawerHeaderTitle = ({ title }: DrawerHeaderTitleProps) => {
  return (
    <TypographyHeading className={styles.drawerHeaderTitle} slot="title">
      {title}
    </TypographyHeading>
  );
};

DrawerHeaderTitle.displayName = "DS.DrawerNew.HeaderTitle";

export default DrawerHeaderTitle;
